// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__EzuFC","input":"styles_input__yOncm"};